<script lang="ts" setup>
defineProps<{
  content: string
  icon: string
  title: string
}>()
</script>

<template>
  <div class="flex h-[calc(50%-6px)] flex-col rounded-3xl bg-white px-3 py-4 md:!p-5">
    <div class="flex items-center">
      <SvgIcon class="mr-3 !size-8 md:mr-[18px] md:!size-9" :name="icon" />

      <strong class="text-lg font-medium leading-[1.22] md:text-[22px] md:leading-[1.27]">
        {{ title }}
      </strong>
    </div>

    <p class="!m-0 !mt-3 text-sm leading-[1.43] md:text-base md:leading-[1.37]">
      {{ content }}
    </p>
  </div>
</template>
